import { render } from "./drop_file_context_menu.vue?vue&type=template&id=0ddfa290"
import script from "./drop_file_context_menu.vue?vue&type=script&lang=js"
export * from "./drop_file_context_menu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__